// BroadcastChannel utility for sync between main console and second screen
const CHANNEL_NAME = "karaoke-console";

class Bus {
  constructor() {
    this.channel = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(CHANNEL_NAME) : null;
    this.listeners = new Set();
    if (this.channel) {
      this.channel.onmessage = (e) => {
        this.listeners.forEach((cb) => cb(e.data));
      };
    }
  }
  post(msg) {
    if (this.channel) this.channel.postMessage(msg);
  }
  on(cb) {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }
}

export const bus = new Bus();
